export default __webpack_public_path__ + "static/media/modular-brand-experience-small.8211579f.jpg";